import { CombinedNameUser, IUser, SeparatedNameUser } from '@/common/Auth';
import { AsyncNotifications } from '@/services/AsyncNotifications';
import User from '@/services/User';
import { Auth } from 'aws-amplify';
import jQuery from 'jquery';
import router from '../router';
import store from './';

interface VuexState {
	user: IUser | undefined;
	coreUser: unknown;
	brokerageId: string;
	isBrokerage: boolean;
}

const state: VuexState = {
	user: undefined,
	brokerageId: '',
	isBrokerage: false,
	coreUser: {},
};

const getters = {
	user: (state: VuexState) => state.user,
	coreUser: (state: VuexState) => state.coreUser,
};

const mutations = {
	setUser: (state: VuexState, user: CombinedNameUser | SeparatedNameUser | undefined): void => {
		if (user && !('name' in user)) {
			const givenName: string = user.given_name.trim();
			const familyName: string = user.family_name.trim();
			delete user.given_name;
			delete user.family_name;
			((user as unknown) as CombinedNameUser).name = `${givenName} ${familyName}`;
		}
		state.user = user as IUser;
	},
	setCoreUser: (state: VuexState, user: unknown | undefined): void => {
		state.coreUser = user;
	},
	setBrokerageId: (state: VuexState, brokerageId: string): void => {
		state.brokerageId = brokerageId;
	},
	setIsBrokerage: (state: VuexState, isBrokerage: boolean): void => {
		state.isBrokerage = isBrokerage;
	},
};

const actions = {
	signout: ({ commit }) => {
		// Remove Auth from store
		commit('setUser', undefined);

		commit('setBrokerageId', null);
		commit('setIsBrokerage', false);
		// Remove Vuex/Auth from localStorage
		window.isLoggedIn = false;

		// Remove data from the saved state.
		store.dispatch('Policy/clearData', null);
		store.dispatch('Payment/clearData', null);
		store.dispatch('OrgAdmin/clearData', null);
		store.dispatch('Organizations/clearData', null);
		store.dispatch('Misc/setLoading', false);

		// Redirect to the login page
		jQuery('body').addClass('not-loggedin');
		router.push({
			name: 'login',
		});

		AsyncNotifications.singleton.disconnect();
	},

	setUser({ commit }, user: CombinedNameUser | SeparatedNameUser | undefined): void {
		commit('setUser', user);
	},

	setCoreUser: ({ commit }, payload: unknown | undefined) => {
		commit('setCoreUser', payload);
	},
	setBrokerageId: ({ commit }, payload: string) => {
		commit('setBrokerageId', payload);
	},
	setIsBrokerage: ({ commit }, payload: boolean) => {
		commit('setIsBrokerage', payload);
	},

	async authenticated({ commit }): Promise<void> {
		const currentSession = await Auth.currentSession();

		const jwtToken = currentSession.getIdToken().getJwtToken();
		if (!jwtToken) {
			router.push({
				name: 'error',
				params: {
					message: 'The authentication response did not include a valid ID token',
				},
			});
			throw Error();
		}

		const base64Payload: string = jwtToken.match(/^(.+)\.(.+)\.(.+)$/)[2];
		const utf8Payload: string = window.atob(base64Payload);

		const user = JSON.parse(utf8Payload) as CombinedNameUser | SeparatedNameUser;
		commit('setUser', user);

		try {
			const getUser = await User.getUser();
			commit('setCoreUser', getUser?.data);
		} catch {
			// Yo :D
		}

		if (user.brokerageId) {
			commit('setBrokerageId', user.brokerageId);
		}
		if (user.isBrokerage) {
			commit('setIsBrokerage', true);
		}
		window.isLoggedIn = true;

		// store.dispatch('Misc/setLoading', true);
		jQuery('body').removeClass('not-loggedin');

		AsyncNotifications.singleton.connect(jwtToken);
	},
};

export { state, getters, mutations, actions };
